<template lang="">
  <div class="map-row">
    <slot></slot>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
